import { SearchPageContent } from "./search-content";
interface SearchSearch {
  q?: string;
  genre?: string;
  style?: string;
  type?: AlbumType;
  format?: FormatCategory;
  country?: string;
  origin?: string;
  year?: number[];
  page?: number;
  label?: string[];
  company?: string[];
  forSale?: boolean;
  sort?: string;
  cursor?: string;
}
function SearchRoute() {
  return <SearchPageContent />;
}
export { SearchRoute as component };